import { ModalProps, ModalService } from '@philips-internal/oswald-ui-components';
import { AbortableCloseEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { generateUUID, isMobile } from '@philips-internal/oswald-ui-utils';

const HASH_PREFIX = '#';

/**
 * WARNING: Don't make calls from this service simultaneously.
 * Otherwise you have problems with modal hash.
 */
export default class PatientModalService {

  private static modalHash = '';
  private static unListeners: { (): void; } [] = [];

  public static openDialog(modalProps: ModalProps, fullscreenOnMobile = false): void {
    PatientModalService.modalHash = HASH_PREFIX + generateUUID();

    PatientModalService.unListeners.push(
      ModalService.addListener(PatientModalService.handleOnOpenModal),
      PatientModalService.removeHashChangeEventListener
    );

    PatientModalService.openDialogModal(modalProps, fullscreenOnMobile);
  }

  private static openDialogModal(modalProps: ModalProps, fullscreenOnMobile: boolean): void {
    const newModalProps: ModalProps = {
      ...modalProps,
      id: PatientModalService.modalHash,
      onBeforeClose: (event: AbortableCloseEvent) => {
        PatientModalService.handleOnCloseModal(event, modalProps.onBeforeClose);
      },
    }

    if(fullscreenOnMobile && isMobile()) {
      ModalService.openFullscreen(newModalProps);
    } else {
      ModalService.openDialog(newModalProps);
    }
  }

  private static handleOnOpenModal(): void {
    window.location.assign(PatientModalService.modalHash);
    window.addEventListener('hashchange', PatientModalService.handleOnHashChange);
  }

  private static handleOnHashChange(): void {
    if(window.location.hash != PatientModalService.modalHash) {
      ModalService.close(PatientModalService.modalHash);
      PatientModalService.unListeners.forEach(unListener => unListener());
    }
  }

  private static handleOnCloseModal(event: AbortableCloseEvent, externalCallback?: (event: AbortableCloseEvent) => void): void {
    if(externalCallback != null) {
      externalCallback(event);
    }

    window.location.replace(HASH_PREFIX)
    PatientModalService.unListeners.forEach(unListener => unListener());
  }

  private static removeHashChangeEventListener(): void {
    window.removeEventListener('hashchange', PatientModalService.handleOnHashChange);
    PatientModalService.modalHash = '';
  }
}